import React from 'react';
import { array } from 'prop-types';

import '../styles/AboutUs.css';

function AboutUs({ descriptions }) {
    return (
        <div>
            {descriptions.map(({ title, body }, i) => (
                <div
                    key={`${title}-${i}`}
                >
                    {title && <h3
                        className={'mb-3'}
                    >
                        {title}
                    </h3>}
                    {body.map((block, i) => (
                        <p
                            key={`${block.substring(0, 20)} ${i}`}>
                            {block}
                        </p>
                    ))}
                </div>
            ))}
        </div>
    );
}

AboutUs.propTypes = {
    descriptions: array,
};

export default AboutUs;